// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__cAXS6","spinner":"Loader_spinner__1-fEu","rotate":"Loader_rotate__1Nzmc","path":"Loader_path__2QWli","dash":"Loader_dash__37MQF"};